import { render, staticRenderFns } from "./dui-file-list.vue?vue&type=template&id=5cf78971&scoped=true&"
import script from "./dui-file-list.vue?vue&type=script&lang=js&"
export * from "./dui-file-list.vue?vue&type=script&lang=js&"
import style0 from "./dui-file-list.vue?vue&type=style&index=0&id=5cf78971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf78971",
  null
  
)

export default component.exports